(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sma-new-fivePotent"] && !Shopify.designMode) return;
  try {
    
(function () {
  var AUTOPLAY_DELAY = 5000;   // 5s between slides
  var RESUME_DELAY   = 4000;   // resume autoplay 4s after last user interaction
  var SCROLL_SETTLE  = 800;    // ms to wait for programmatic scroll to settle

  function initCarousel(root) {
    if (!root || root.dataset.smaCarouselInit === '1') return;
    root.dataset.smaCarouselInit = '1';

    var track = root.querySelector('[data-carousel-track]');
    var dots  = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var boxes = track ? Array.prototype.slice.call(track.querySelectorAll('.sma-new-five-box')) : [];

    if (!track || boxes.length === 0 || dots.length === 0) return;

    var currentIndex = 0;
    var autoplayTimer = null;
    var resumeTimer = null;
    var scrollSettleTimer = null;
    var scrollDebounceTimer = null;
    var isInView = false;
    var userPaused = false;
    var isProgrammaticScroll = false;

    function setActiveDot(index) {
      for (var i = 0; i < dots.length; i++) {
        var isActive = (i === index);
        dots[i].classList.toggle('is-active', isActive);
        dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    function scrollToIndex(index) {
      var box = boxes[index];
      if (!box) return;
      isProgrammaticScroll = true;
      var trackRect = track.getBoundingClientRect();
      var boxRect = box.getBoundingClientRect();
      var offsetLeft = boxRect.left - trackRect.left + track.scrollLeft;
      try {
        track.scrollTo({ left: offsetLeft, behavior: 'smooth' });
      } catch (e) {
        track.scrollLeft = offsetLeft;
      }
      clearTimeout(scrollSettleTimer);
      scrollSettleTimer = setTimeout(function () {
        isProgrammaticScroll = false;
      }, SCROLL_SETTLE);
    }

    function goToIndex(index) {
      var len = boxes.length;
      currentIndex = ((index % len) + len) % len; // wrap both directions
      scrollToIndex(currentIndex);
      setActiveDot(currentIndex);
    }

    function next() {
      goToIndex(currentIndex + 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isInView || userPaused) return;
      autoplayTimer = setInterval(next, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function pauseForUser() {
      userPaused = true;
      stopAutoplay();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        userPaused = false;
        if (isInView) startAutoplay();
      }, RESUME_DELAY);
    }

    // Update active dot based on actual scroll position (debounced)
    function onScroll() {
      clearTimeout(scrollDebounceTimer);
      scrollDebounceTimer = setTimeout(function () {
        if (isProgrammaticScroll) return;
        var trackRect = track.getBoundingClientRect();
        var closestIndex = 0;
        var closestDist = Infinity;
        for (var i = 0; i < boxes.length; i++) {
          var boxRect = boxes[i].getBoundingClientRect();
          var dist = Math.abs(boxRect.left - trackRect.left);
          if (dist < closestDist) {
            closestDist = dist;
            closestIndex = i;
          }
        }
        currentIndex = closestIndex;
        setActiveDot(currentIndex);
      }, 100);
    }
    track.addEventListener('scroll', onScroll, { passive: true });

    // User interaction → pause autoplay
    var pauseEvents = ['pointerdown', 'touchstart', 'mousedown', 'wheel'];
    for (var i = 0; i < pauseEvents.length; i++) {
      track.addEventListener(pauseEvents[i], pauseForUser, { passive: true });
    }

    // Dot click → jump + pause
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        pauseForUser();
        goToIndex(i);
      });
    });

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else if (isInView && !userPaused) {
        startAutoplay();
      }
    });

    // Viewport detection → autoplay only when visible
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isInView = entry.isIntersecting;
          if (isInView && !userPaused) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        });
      }, { threshold: 0.3 });
      io.observe(root);
    } else {
      // Fallback: just autoplay
      isInView = true;
      startAutoplay();
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.sma-new-fivePotent.is-carousel');
    for (var i = 0; i < nodes.length; i++) initCarousel(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when section is loaded / re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
